import { createNamespace } from "Common/namespaceUtils/namespaceRedux";
export const NAMESPACE = "tasksLogs";
export const FULL_NAMESPACE = createNamespace(NAMESPACE);
